import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import InputField from "../../component/input-field";
import Table, { TableRow } from "../../component/table";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../component/modal-popup/customeModal";

// Importing redux actions
import { useDispatch, useSelector } from "react-redux";
import {
  getConfigurationDataWithSetting,
  getActivityConfigurationSettingMapping,
} from "../../redux/actions/configurationAction";
import {
  getAllToDO,
  getAllActivityWithCustomField,
} from "../../redux/actions/todo";

const ViewConfiguration = (props) => {
  const configurationID = useLocation().pathname.split("/")[3];

  // Redux hook
  const dispatch = useDispatch();
  const { allActivityResponse } = useSelector((state) => state.todo);

  const getConfigurationData = () => {
    const request = {
      configurationID,
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content="Something went wrong. Please try again later."
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(getConfigurationDataWithSetting(request));
  };

  // API call for getting configuration mapping by configurationID
  const getConfigurationMapping = () => {
    const request = {
      configuration_id: configurationID,
      onSuccess: () => {},
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content="Something went wrong. Please try again later."
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(getActivityConfigurationSettingMapping(request));
  };

  // Function to get Activity
  const getExistingActivity = () => {
    const request = {
      onError: () => {
        console.log("error");
      },
    };
    dispatch(getAllActivityWithCustomField(request));
    // dispatch(getAllToDO(() => {}));
  };

  useEffect(() => {
    getConfigurationData();
    getExistingActivity();
    getConfigurationMapping();
  }, []);

  return (
    <div className="min-h-full bg-white sm:mx-6 lg:mx-8">
      <div>
        <div className="flex justify-start space-x-2 p-1.5">
          <Link
            to="/workflows"
            className="btn-sm !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white"
          >
            Back
          </Link>
        </div>
        <header className="flex justify-center bg-gray-50">
          <HeaderStep n="01" h="Workflow" />
          <HeaderStep n="02" h="Mapping" />
        </header>

        <FirstStep />
      </div>
    </div>
  );
};

ViewConfiguration.auth = {
  path: "/configuration/view/:id",
  role: "super-admin",
};
export default ViewConfiguration;

const HeaderStep = ({ n, h, p, active }) => {
  let cssClass =
    "flex justify-center items-center w-10 h-10 rounded-full border-2 ";

  return (
    <div className="flex items-center space-x-3 w-1/2 h-auto p-3 border-slate-200 border-[1px]">
      <span className={cssClass}>{n}</span>
      <div className="">
        <h4 className="font-medium">{h}</h4>
        <p className="font-normal">{p}</p>
      </div>
    </div>
  );
};

const FirstStep = () => {
  const { configurationWithSettingData, configurationSettingMappingData } =
    useSelector((state) => state.configurationReducer);
  // const { todoList } = useSelector((state) => state.todo);
  const { allActivityResponse } = useSelector((state) => state.todo);
  return (
    <div className="sm:flex flex-auto h-screen">
      <div className="sm:w-1/2 sm:h-full w-full bg-gray-50">
        <div className="w-full mx-auto p-3">
          <InputField
            type="text"
            label="Workflow Name"
            placeholder="Enter Workflow Name"
            wrapperClass="my-3"
            value={
              configurationWithSettingData
                ? configurationWithSettingData.configuration_name
                : ""
            }
            disabled
          />
          <InputField
            type="text"
            label="Description"
            placeholder="Enter Description"
            wrapperClass="my-3"
            value={
              configurationWithSettingData
                ? configurationWithSettingData.configuration_desc
                : ""
            }
            disabled
          />
          <Table
            // heads={["Header Name", "Value"]}
            heads={[
              {
                headName: "Header Name",
                isSort: false,
                value: "Header Name",
              },
              {
                headName: "Value",
                isSort: false,
                value: "Value",
              },
            ]}
            tClass="table-auto w-full"
            hClass="text-xs font-semibold uppercase text-slate-500 bg-slate-50 border-t border-b border-slate-200 w-10"
            bClass="text-sm divide-y divide-slate-200"
            thClass="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap text-left font-semibold "
          >
            {configurationWithSettingData
              ? configurationWithSettingData.configuration_settings.map(
                  ({ header_name, header_value }, i) => {
                    return (
                      <TableRow
                        key={i}
                        row={{ header_name, header_value }}
                        tdClass="px-2 py-3 whitespace-nowrap text-indigo-00 bg-white"
                      />
                    );
                  }
                )
              : null}
          </Table>
        </div>
      </div>
      <div className="sm:w-1/2 sm:h-full w-full">
        <div className="w-full overflow-x-auto shadow-lg mx-auto p-3">
          <Table
            heads={[
              {
                headName: "To Do",
                isSort: false,
                value: "To Do",
              },
              {
                headName: "Compulsory",
                isSort: false,
                value: "Compulsory",
              },
              {
                headName: "Link To Do",
                isSort: false,
                value: "Link To Do",
              },
              {
                headName: "Duration",
                isSort: false,
                value: "Duration",
              },
              {
                headName: "repeat/loop",
                isSort: false,
                value: "repeat/loop",
              },
            ]}
            tClass="table-auto w-full"
            hClass="text-xs font-semibold  text-slate-500 bg-slate-50 border-t border-b border-slate-200 w-10"
            bClass="text-sm divide-y divide-slate-200"
            thClass="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap text-left font-semibold "
          >
            {configurationSettingMappingData.length > 0
              ? configurationSettingMappingData.map(
                  (
                    {
                      activity,
                      name,
                      is_mandatory,
                      loop_activity,
                      link_activity,
                      duration,
                    },
                    i
                  ) => {
                    return (
                      <tr className="px-2 py-3 whitespace-nowrap" key={i}>
                        <td className="px-2 py-3 whitespace-nowrap">
                          {activity.name}
                        </td>
                        <td className="px-2 py-2 whitespace-nowrap">
                          <div className="w-1/2 flex justify-center">
                            <input
                              type="checkbox"
                              className="form-checkbox"
                              defaultValue={is_mandatory}
                              checked={is_mandatory}
                              disabled
                            />
                          </div>
                        </td>
                        <td className="px-2 py-3 whitespace-nowrap">
                          {allActivityResponse.length > 0
                            ? allActivityResponse.find(
                                (item) => item.id === link_activity
                              )?.name
                            : null}
                        </td>
                        <td className="px-2 py-3 whitespace-normal">
                          {duration}
                        </td>
                        <td className="px-2 py-3 whitespace-nowrap">
                          {allActivityResponse.length > 0
                            ? allActivityResponse.find(
                                (item) => item.id === loop_activity
                              )?.name
                            : null}
                        </td>
                      </tr>
                    );
                  }
                )
              : null}
          </Table>
        </div>
      </div>
    </div>
  );
};
